import { styled, css } from "styled-components";

import { colorCSS, formCSS, fontSizes, radius } from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

// Convert object syntax to template literal for SSR compatibility
const contactFormStyles = css`
    ${redundantCssFromKebab("display", "none")}
    ${redundantCssFromKebab("text-align", "left")}

    #support-form-contact-title {
        ${redundantCssFromKebab("display", "none")}
    }

    div#support-form-app h5 {
        ${redundantCssFromKebab("display", "none")}
    }

    a[type="button"] {
        ${redundantCssFromKebab("appearance", "none")}
    }

    .ak-message,
    #trello-login,
    section,
    .confirmation {
        ${redundantCssFromKebab("border-radius", `${radius.small}`)}
        ${redundantCssFromKebab("padding", "1rem")}
        ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}

        p {
            ${redundantCssFromKebab("margin-bottom", "1rem")}

            &:last-child {
                ${redundantCssFromKebab("margin-bottom", "0.25rem")}
            }
        }

        span[role="presentation"] {
            ${redundantCssFromKebab("margin-top", "0.1rem")}
        }
    }

    .ak-message.warning,
    .ak-message.warning-1 {
        ${redundantCssFromKebab("background-color", `${colorCSS("R50")}`)}
        ${redundantCssFromKebab("border", `1px solid ${colorCSS("R75")}`)}
    }

    #trello-login {
        ${redundantCssFromKebab("background-color", `${colorCSS("B50")}`)}
        ${redundantCssFromKebab("border", `1px solid ${colorCSS("B75")}`)}
    }

    .confirmation {
        ${redundantCssFromKebab("background-color", `${colorCSS("G50")}`)}
        ${redundantCssFromKebab("border", `1px solid ${colorCSS("G75")}`)}

        h1#content_title {
            ${redundantCssFromKebab("text-align", "center")}

            br {
                ${redundantCssFromKebab("display", "none")}
            }
        }

        .ak-message {
            ${redundantCssFromKebab("text-align", "center")}
        }

        p#bottom-text {
            ${redundantCssFromKebab("margin-bottom", "0.25rem")}
        }
    }

    ${formCSS}

    form {
        ${redundantCssFromKebab("padding-top", "1.5rem")}

        label {
            ${redundantCssFromKebab("display", "block")}
            ${redundantCssFromKebab("line-height", "1.2")}

            > div {
                ${redundantCssFromKebab("color", `${colorCSS("N800")}`)}
                ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
                ${redundantCssFromKebab("font-weight", "normal")}
            }

            &[role="presentation"] {
                ${redundantCssFromKebab("color", `${colorCSS("R500")}`)}
            }
        }

        input,
        textarea,
        .custom-ak-select__control,
        button {
            ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
        }

        .custom-ak-select__menu > div {
            ${redundantCssFromKebab("padding-bottom", "0")}
            ${redundantCssFromKebab("padding-top", "0")}
        }

        .custom-ak-select__single-value {
            ${redundantCssFromKebab("overflow", "visible")}
        }

        .custom-ak-select__value-container {
            ${redundantCssFromKebab("padding-top", "0")}
            ${redundantCssFromKebab("padding-bottom", "0")}
        }

        #react-select-inquiryCategory-input {
            ${redundantCssFromKebab("padding", "0")}
        }

        .custom-ak-select__control,
        .dropzone {
            ${redundantCssFromKebab("background", `${colorCSS("N20")}`)}
            ${redundantCssFromKebab("border", `1px solid ${colorCSS("N40")}`)}
            ${redundantCssFromKebab("border-radius", `${radius.small}`)}
        }

        .custom-ak-select__control,
        .dropzone,
        input,
        textarea {
            ${redundantCssFromKebab("margin-bottom", "1rem")}
        }

        input,
        textarea {
            ${redundantCssFromKebab("display", "block")}
        }

        .dropzone {
            ${redundantCssFromKebab("text-align", "center")}
            ${redundantCssFromKebab("padding", "1rem")}
            ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}

            a[type="button"] {
                ${redundantCssFromKebab("height", "auto")}
                ${redundantCssFromKebab("padding", "0 !important")}
                ${redundantCssFromKebab("vertical-align", "baseline")}
            }
        }

        #dropzone-attached-files {
            ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
            ${redundantCssFromKebab("margin-bottom", "1rem")}

            .dropzone-pill-wrapper {
                ${redundantCssFromKebab(
                    "border-top",
                    `1px solid ${colorCSS("N40")}`
                )}
                ${redundantCssFromKebab("display", "flex")}
                ${redundantCssFromKebab("padding", "0.5rem 0")}
                ${redundantCssFromKebab("width", "100%")}

                .dropzone-pill-text {
                    ${redundantCssFromKebab("flex-grow", "1")}
                }

                .dropzone-pill-button {
                    ${redundantCssFromKebab("cursor", "pointer")}
                }
            }
        }

        .form-error-message {
            ${redundantCssFromKebab("color", `${colorCSS("R500")}`)}
            ${redundantCssFromKebab("margin", "-0.5rem 0 1.5rem")}

            h4,
            p {
                ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
                ${redundantCssFromKebab("font-weight", "normal")}
                ${redundantCssFromKebab("margin-bottom", "0.5rem")}
            }
        }

        .captcha-field {
            ${redundantCssFromKebab("margin", "2rem 0 1rem")}
        }

        button[type="submit"] {
            ${redundantCssFromKebab("margin-bottom", "0")}
        }

        .ak-field-group {
            ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}

            input[type="checkbox"] {
                ${redundantCssFromKebab("float", "left")}
                ${redundantCssFromKebab("margin", "0.4rem 0.25rem 0 0")}
                ${redundantCssFromKebab("width", "auto")}
            }
        }
    }

    &[data-open="true"] {
        ${redundantCssFromKebab("display", "block")}
    }
`;

export const ContactFormContainer = styled.div`
    ${contactFormStyles}
`;
